import { ComponentProps, useState } from 'react';

import FieldIconButton from '../FieldIconButton/FieldIconButton';
import TextField from '../TextField/TextField';

import showIcon from './graphics/show.svg?raw';

type PasswordFieldProps = {
    clearText?: boolean;
    strengthIndicator?: boolean;
    value?: string;
    defaultValue?: string;
    onClearTextChange?: (clearText: boolean) => void;
} & Omit<ComponentProps<typeof TextField>, 'value' | 'defaultValue'>;

const PasswordField = ({
    clearText,
    label,
    onClearTextChange,
    ...textFieldProps
}: PasswordFieldProps) => {
    const [toggledClearText, setToggledClearText] = useState(clearText);
    const valueToUse = clearText ?? toggledClearText;
    const toggleClearText = () => {
        onClearTextChange?.(!valueToUse);
        setToggledClearText(!valueToUse);
    };

    return (
        <TextField
            type={valueToUse ? 'text' : 'password'}
            label={label}
            {...textFieldProps}
        >
            <FieldIconButton
                variant={valueToUse ? 'default' : 'subtle'}
                icon={showIcon}
                onClick={toggleClearText}
                aria-label={valueToUse ? 'Hide password' : 'Show password'}
            />
        </TextField>
    );
};

export default PasswordField;
